import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import axios from 'axios'
import { AnalyticsDashboardStateInterface } from '../interfaces/analytics-dashboard.state.interface'
import { ReportLightResponseInterface } from '../../core/interface/report/report-light-response.interface'
import { PaginationResponseInterface } from '../../core/interface/pagination-response.interface'
import {
  analyticsDashboardGetPrivateReports,
  analyticsDashboardGetPrivateReportsNext,
} from '../actions/private-reports-dashboard.actions'

const initialState: AnalyticsDashboardStateInterface = {
  isLoadingRecommendedReports: false,
  recommendedReports: null,
  isLoadingInternalReports: false,
  isLoadingInternalReportsNext: false,
  internalReports: null,
  cancelTokenInternalReportsNext: null,
}

const privateReportslice = createSlice({
  name: 'privateReportsState',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(
        analyticsDashboardGetPrivateReports.pending,
        (
          state: AnalyticsDashboardStateInterface,
        ): AnalyticsDashboardStateInterface => ({
          ...state,
          isLoadingInternalReports: true,
        }),
      )
      .addCase(
        analyticsDashboardGetPrivateReports.fulfilled,
        (
          state: AnalyticsDashboardStateInterface,
          action: PayloadAction<PaginationResponseInterface<ReportLightResponseInterface> | null>,
        ): AnalyticsDashboardStateInterface => ({
          ...state,
          internalReports: action.payload,
          isLoadingInternalReports: false,
        }),
      )
      .addCase(
        analyticsDashboardGetPrivateReports.rejected,
        (
          state: AnalyticsDashboardStateInterface,
        ): AnalyticsDashboardStateInterface => ({
          ...state,
          isLoadingInternalReports: false,
        }),
      )
      .addCase(
        analyticsDashboardGetPrivateReportsNext.pending,
        (
          state: AnalyticsDashboardStateInterface,
        ): AnalyticsDashboardStateInterface => {
          const { cancelTokenInternalReportsNext } = state
          if (cancelTokenInternalReportsNext) {
            cancelTokenInternalReportsNext.cancel()
          }
          return {
            ...state,
            isLoadingInternalReportsNext: true,
            cancelTokenInternalReportsNext: axios.CancelToken.source(),
          }
        },
      )
      .addCase(
        analyticsDashboardGetPrivateReportsNext.fulfilled,
        (
          state: AnalyticsDashboardStateInterface,
          action: PayloadAction<PaginationResponseInterface<ReportLightResponseInterface> | null>,
        ): AnalyticsDashboardStateInterface => ({
          ...state,
          isLoadingInternalReportsNext: false,
          internalReports: {
            count: action.payload?.count || 0,
            next: action.payload?.next || '',
            previous: action.payload?.previous || '',
            results: [
              ...(state.internalReports?.results || []),
              ...(action.payload?.results || []),
            ],
          },
        }),
      )
      .addCase(
        analyticsDashboardGetPrivateReportsNext.rejected,
        (
          state: AnalyticsDashboardStateInterface,
        ): AnalyticsDashboardStateInterface => ({
          ...state,
          isLoadingInternalReportsNext: false,
        }),
      )
  },
})

export const privateReportsDashboardReducer = privateReportslice.reducer
